"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useGetUpcoming = _interopRequireDefault(require("../../hooks/useGetUpcoming"));
var _AirDateFormatter = _interopRequireDefault(require("./AirDateFormatter"));
var _StringList = _interopRequireDefault(require("./StringList"));
var _helpers = require("./../../utils/helpers");
const determineSeasonEpStr = program => {
  let startIndex;
  for (let i = 0; i < program.title_code.length; i++) {
    if (!isNaN(Number.parseInt(program.title_code.charAt(i), 10))) {
      startIndex = i;
      break;
    }
  }
  return program.title_code.slice(startIndex);
};
function GetAirdateWrapper({
  programId,
  programType = 'series',
  separatorType = 'pipe',
  includeEpisode = false
}) {
  const [nextAirDate, setNextAirDate] = (0, _react.useState)(null);
  const [episode, setEpisode] = (0, _react.useState)(null);
  (0, _useGetUpcoming.default)({
    programId,
    programType
  }).then(results => {
    let airdate = null;
    let ep = null;
    if (results.length) {
      airdate = `${results[0].start_date_parse} ${(0, _helpers.convert12to24)(results[0].start_time)}`;
      if (includeEpisode) {
        var _results$;
        if ((_results$ = results[0]) !== null && _results$ !== void 0 && _results$.episode_number) {
          var _results$2;
          ep = `${(_results$2 = results[0]) === null || _results$2 === void 0 ? void 0 : _results$2.episode_number}: ${results[0].title_name}`;
        } else {
          ep = `${determineSeasonEpStr(results[0])}: ${results[0].title_name}`;
        }
      }
    }
    setNextAirDate(airdate);
    setEpisode(ep);
  });
  if (nextAirDate === null) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (programId === '') return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return includeEpisode ? /*#__PURE__*/_react.default.createElement(_StringList.default, {
    list: [/*#__PURE__*/_react.default.createElement(_AirDateFormatter.default, {
      airdateStr: nextAirDate,
      separatorType: separatorType
    }), episode],
    separatorType: "pipe"
  }) : /*#__PURE__*/_react.default.createElement(_AirDateFormatter.default, {
    airdateStr: nextAirDate,
    separatorType: separatorType
  });
}
var _default = exports.default = GetAirdateWrapper;